import React from 'react';
import _ from 'lodash';
import styled, { ThemeProvider, withTheme } from 'styled-components';
import { FavMarketRow } from '../components';

const List = styled.div`
  height: auto;
  overflow: scroll;
`;

const FavExList = ({ theme, watchList, exchange, markets, selectMarket }) => (
  <ThemeProvider theme={theme}>
    <List>
      {_.map(markets, market => (
        <FavMarketRow
          watchList={watchList}
          exchange={exchange}
          selectMarket={selectMarket}
          market={market}
          key={market.id}
        />
      ))}
    </List>
  </ThemeProvider>
);

export default withTheme(FavExList);



// WEBPACK FOOTER //
// ./src/components/FavMarketList.js